// @ts-nocheck
import { ProductContextModel } from "@insite/client-framework/Components/ProductContext";
import getSampleProductInfo from "@store/Framework/Common/Utilities/samples/getSampleProductInfo";
import mergeProps from "@toolkit/Framework/Common/Utilities/mergeProps";
import { useMemo } from "react";

const useSampleProductContext = (baseProductContext: ProductContextModel) => {
    return useMemo(() => {
        return mergeProps<ProductContextModel>(baseProductContext, {
            productInfo: getSampleProductInfo(baseProductContext.productInfo),
        } as ProductContextModel);
    }, [baseProductContext]);
};

export default useSampleProductContext;
